module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/favicon.ico
// module id = 854
// module chunks = 0